/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_translate_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free protein translation tool. Translate a DNA or RNA coding sequence into single-letter amino acids in any of the three reading frames, with an optional stop at the first stop codon.`)
};

const es_translate_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herramienta gratuita de traducción de proteínas. Traduce una secuencia codificante de ADN o ARN en aminoácidos de una sola letra en cualquiera de los tres marcos de lectura, con parada opcional en el primer codón de parada.`)
};

const de_translate_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloses Tool zur Proteinübersetzung. Übersetzen Sie eine DNA- oder RNA-Kodierungssequenz in Einzelbuchstaben-Aminosäuren in einem der drei Leseraster, mit optionalem Stopp am ersten Stoppcodon.`)
};

const nl_translate_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis eiwitvertaaltool. Vertaal een coderende DNA- of RNA-sequentie naar aminozuren met éénletterafkortingen in elk van de drie leesframes, met een optionele stop bij het eerste stopcodon.`)
};

const fr_translate_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outil gratuit de traduction de protéines. Traduisez une séquence codante d'ADN ou d'ARN en acides aminés à une lettre dans l'un des trois cadres de lecture, avec un arrêt optionnel au premier codon stop.`)
};

const it_translate_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strumento gratuito di traduzione proteica. Traduce una sequenza codificante di DNA o RNA in amminoacidi a lettera singola in una delle tre fasi di lettura, con un'opzione per fermarsi al primo codone di stop.`)
};

const pt_br2_translate_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramenta gratuita de tradução de proteínas. Traduza uma sequência codificante de DNA ou RNA em aminoácidos de uma letra em qualquer um dos três quadros de leitura, com parada opcional no primeiro códon de parada.`)
};

const pt_translate_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramenta gratuita de tradução de proteínas. Traduza uma sequência codificante de ADN ou ARN em aminoácidos de uma letra em qualquer uma das três grelhas de leitura, com paragem opcional no primeiro codão de paragem.`)
};

const ja_translate_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のタンパク質翻訳ツール。DNAまたはRNAコード配列を3つの読み枠のいずれかで1文字アミノ酸に翻訳し、最初の終止コドンで停止するオプションもあります。`)
};

const zh_translate_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费蛋白质翻译工具。将 DNA 或 RNA 编码序列翻译为单字母氨基酸，可选择三个阅读框中的任意一个，并可选择在遇到第一个终止密码子时停止。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const translate_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.translate_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("translate_meta_description", locale)
	if (locale === "en") return en_translate_meta_description(inputs)
	if (locale === "es") return es_translate_meta_description(inputs)
	if (locale === "de") return de_translate_meta_description(inputs)
	if (locale === "nl") return nl_translate_meta_description(inputs)
	if (locale === "fr") return fr_translate_meta_description(inputs)
	if (locale === "it") return it_translate_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_translate_meta_description(inputs)
	if (locale === "pt") return pt_translate_meta_description(inputs)
	if (locale === "ja") return ja_translate_meta_description(inputs)
	return zh_translate_meta_description(inputs)
};